import { stringify } from 'qs';
import { query, request } from 'src/utils/request';

// 获取区划管理列表
export function getDistrictsList(params) {
  return request(`/api/zlbuser/districts?${stringify(params)}`);
}

// 获取区划负责人列表
export function getDistrictsManageList(params) {
  return request('/api/zlbuser/tenant/manager', {
    params,
  });
}

// 设置区划负责人
export function setDistrictsManage(data) {
  return request('/api/zlbuser/tenant/manager', {
    data,
    method: 'post',
  });
}

// 获取省级区划
export function getProvinceDistrictList(params) {
  return request('/api/zlbuser/province/district', {
    params,
  });
}

// 分页查询机构下级单位列表
export function getInstitutionList(params) {
  return request('/api/zlbuser/institution/operational/institution/list', {
    params,
  });
}

// 根据区划code查询费控规则
export function getCostControlRule(params) {
  return request(`/zlb/cost/control/standard/get-by-district/${params.tenantCode}`);
}

// 标签分类查询
export async function getTagTypeList(params) {
  return request('/api/zlbuser/tagtype/list', { params });
}

// 标签查询
export async function getTagList(params) {
  return request('/api/zlbuser/tag/list', { params });
}

// 标签
export async function removeDomainTag(data) {
  return request('/api/zlbuser/tag/removeDomainTag', {
    data,
    method: 'post',
  });
}

// 标签
export async function addDomainTag(data) {
  return request('/api/zlbuser/tag/addDomainTag', {
    data,
    method: 'post',
  });
}

// 区划配置标签
export function submitManageTag(data) {
  return request('/api/zlbuser/tag/updateDomainTag', {
    data,
    method: 'post',
  });
}

// 单位配置标签
export function submitCompanyTag(data) {
  return request('/api/zlbuser/tag/updateBillTag', {
    data,
    method: 'post',
  });
}

// 标签联合查询
export function getTagCombineList(params) {
  return request('/api/zlbuser/tag/tagCombineList', {
    params,
  });
}

// 核算系统枚举列表
export function reqAccountingList(params) {
  return request('/zlb/api/archive/accounting/list', {
    params,
  });
}

// 获取区划下核算系统详情
export function reqAccountingDetail(params) {
  return request('/zlb/api/archive/accounting/detail', {
    params,
  });
}

// 保存更新区划下的核算系统
export function reqAccountingSaveOrUpdate(data) {
  return request('/zlb/api/archive/accounting/save-or-update', {
    data,
    method: 'post',
  });
}

export function updateFundPayStatus(params) {
  return request('/zlb/api/pay/config/batchEdit', {
    method: 'POST',
    data: params,
  });
}
// 切换是否限制业务员提交报销接口
export function updateLimitReimbursement(params) {
  return request('/zlb/api/expense/config/edit-tenant-config', {
    method: 'POST',
    data: params,
  });
}

// 查询是否限制业务员提交报销接口
export function getLimitReimbursement(params) {
  return request('/zlb/api/expense/config/tenant-config', {
    method: 'POST',
    data: params,
  });
}

// 查询配置
export function reqAccountConfig(params) {
  return request('/zlb/api/pay/config/query-close-account-config', {
    method: 'POST',
    data: params,
  });
}

// 表单和流程配置页面初始化接口(更改后的)
export function reqFormProcessInit(params) {
  return request('/zlb/api/mbp/baida/config/info', {
    params,
  });
}
// 费用类型配置
export function expenseEdit(params) {
  return request('/zlb/api/expense/config/edit', {
    method: 'POST',
    data: params,
  });
}

// 表单和流程配置页面新增单据
export function reqFormProcessAdd(params) {
  return request('/zlb/api/mbp/baida/form-template/add', {
    method: 'POST',
    data: params,
  });
}

// 表单和流程配置页面编辑单据
export function reqFormProcessEdit(params) {
  return request('/zlb/api/mbp/baida/form-define/update', {
    method: 'POST',
    data: params,
  });
}

// 表单和流程配置页面单据列表
export function reqFormProcessList(params) {
  return request('/zlb/api/mbp/baida/form-template/list-by-tenant', {
    params,
  });
}

// 表单和流程配置页面是否启用编辑(更改后)
export function reqIsFormProcessEdit(params) {
  return request('/zlb/api/mbp/baida/config/edit', {
    method: 'POST',
    data: params,
  });
}

// 获取当前区划是否开启百搭
export function reqIsBaidaFormUsed(params) {
  return query('/zlb/api/mbp/baida/common/enable-status', {
    params: {
      configKey: 'baidaDistrictConfig',
      bizCode: window?.currentUserIdentity?.tenantCode,
      ...params,
    },
  });
}

// 根据快照code获取单据详情
export function getBySnapshotCode(formDefineCode) {
  /* return query('/zlb/api/mbp/baida/form-define/get-info-by-snapshot-code', {
    params: {
      formSnapshotCode: formSnapshotCode
    }
  }); */
  return query('/zlb/api/mbp/baida/form-define/get-latest-snapshot', {
    params: {
      formDefineCode: formDefineCode,
    },
  });
}
// 获取租户类型树
export function getTenantTypeTree() {
  return query('/api/zlbuser/tenant/types/trees');
}
// 获取租户列表
export function getTenantList(params) {
  return query(`/api/zlbuser/tenant/list?${stringify(params)}`);
}

// 获取租户详情
export function getTenantDetail(id) {
  return query(`/api/zlbuser/tenant/${id}`);
}

// 创建租户
export function createTenant(data) {
  return request('/api/zlbuser/tenant', {
    method: 'POST',
    data,
  });
}

// 更新租户
export function updateTenant({ tenantId, ...data }) {
  return request(`/api/zlbuser/tenant/${tenantId}`, {
    method: 'PUT',
    data,
  });
}

// 启用/停用租户
export function changeTenantStatus(data) {
  return request('/api/zlbuser/tenant/status', {
    method: 'POST',
    data,
  });
}

// 获取租户已订购应用
export function getTenantSubscribeTree(params) {
  return query('/api/workbench/subscription/tenant/subscribe/functions/tree', {
    params,
  });
}

// 单位测根据模版添加单据
export function addFormDefineByTemplate(params) {
  return request('/zlb/api/mbp/baida/form-define/add-by-template', {
    method: 'POST',
    data: params,
  });
}
// 单位测获取模版列表
export function getTemplateByOrg(params) {
  return request('/zlb/api/mbp/baida/form-template/list-by-org', {
    method: 'GET',
    params,
  });
}

// 获取单据类型列表
export function getTemplateTypeList(params) {
  return request('/zlb/api/mbp/baida/form-define/list-define-type', {
    method: 'GET',
    params,
  });
}

// 获取配置详情
export function getInvoiceConfigDetail(data) {
  return query('/zlb/api/invoice/config/detail', {
    method: 'POST',
    data,
  });
}

// 保存配置
export function saveInvoiceConfig(data) {
  return query('/zlb/api/invoice/config/save', {
    method: 'POST',
    data,
  });
}

// 获取科目余额强弱控方式
// https://yapi.cai-inc.com/project/2991/interface/api/741522
export function getBalanceControlConfig(data) {
  return query('/zlb/budget/config/tenant/subject-balance-control-type/get', {
    method: 'POST',
    data,
  });
}

// 保存科目余额强弱控方式配置
// https://yapi.cai-inc.com/project/2991/interface/api/741514
export function saveBalanceControlConfig(data) {
  return query('/zlb/budget/config/tenant/subject-balance-control-type/save', {
    method: 'POST',
    data,
  });
}

// 单据schema赋值
export function copyBaidaSchema(data) {
  return request('/zlb/api/mbp/baida/form-define/copy', {
    method: 'POST',
    data,
  });
}
// 获取消息配置
export function getMessageConfig(params) {
  return query('/zlb/api/sop/message/config/tuoshou', {
    method: 'GET',
    params,
  });
}
// 提交消息配置
export function saveMessageConfig(data) {
  return request('/zlb/api/sop/message/config/tuoshou/save', {
    method: 'POST',
    data,
  });
}
